import React, { useEffect, useState } from 'react';

// import faq_data from '../../file/faq.json';
import Contact from "./contact";
import { useTranslation } from 'react-i18next';

const FaqElement = (props) => {
  function toggleFaqElement(event) {

    let faqBlock = event.target.parentNode;
    let faqBlockState = faqBlock.classList.contains("open");

    let allFaqBlock = document.getElementsByClassName("faq_block");

    [].forEach.call(allFaqBlock, function (b) {
      b.classList.remove("open");
    });

    if (faqBlockState === true)
      faqBlock.classList.remove("open");
    else
      faqBlock.classList.add("open");
  }

  return (
    <div className="faq_block">
      <div className="noselect faq_title" onClick={(e) => toggleFaqElement(e)}
        dangerouslySetInnerHTML={{ __html: props.title }}></div>
      <div className={"faq_content"}>
        {props.content.map((p, key) => (
          <p key={key} dangerouslySetInnerHTML={{ __html: p }} />
        ))}
      </div>
    </div>
  );
};

const Faq = () => {
  const { i18n } = useTranslation();

  const [faq_data, setFaqData] = useState(null);

  useEffect(() => {
    const loadFaqData = async () => {
      try {
        const data = await import(`../../file/faq_${i18n.language}.json`);
        setFaqData(data);
      } catch (error) {
        console.error('Error loading FAQ data:', error);
      }
    };

    loadFaqData();
  }, [i18n.language]);

  if (!faq_data) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <div id={"faqStrate1"} className={"strate bottom"}>
        <h1>FAQ</h1>
        <div id={"faq_block_wrapper"}>
          {faq_data.faq.map((item, key) => (
            <FaqElement key={key} title={item.title} content={item.content} />))}
        </div>
      </div>
      <Contact showTitle={false} />
    </>
  );
};

export default Faq;
